import React from "react";
import { Provider, ProgressCircle } from "@react-spectrum/s2";
import "@react-spectrum/s2/page.css";

function LoadingSpinner() {
  return (
    <Provider background="layer-2">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100vw",
          height: "100vh",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <ProgressCircle
          size="L"
          aria-label="Loading authentication status"
          isIndeterminate
          staticColor
        />
      </div>
    </Provider>
  );
}

export default LoadingSpinner;
